import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// Category
function UpdateCategory(cat) {
  cat.action = "cat";
  return client.put("resources.php", cat);
}

function CreateCategory(cat) {
  cat.action = "cat";
  return client.post("resources.php", cat);
}

function GetCategories(id) {
  const params = {
    action: "cat"
  };
  return client.get("resources.php", { params });
}

function GetResources(id) {
  const params = {
    id: id,
    action: "res"
  };
  return client.get("resources.php", { params });
}

function UpdateResource(res) {
  res.action = "res";
  return client.put("resources.php", res);
}

function CreateResource(res) {
  res.action = "res";
  return client.post("resources.php", res);
}

function DeleteCategory(id) {
  const params = { id: id, action: "cat" };
  return client.delete("resources.php", { params });
}

function DeleteResource(id) {
  const params = { id: id, action: "res" };
  return client.delete("resources.php", { params });
}

export {
  UpdateCategory,
  CreateCategory,
  UpdateResource,
  CreateResource,
  DeleteCategory,
  DeleteResource,
  GetCategories,
  GetResources
};
